<template>
  <div class="ndata">
    <el-header>
      <div class="ndata-head">
        <img :src="websitBanner" style="width:100%;vertical-align: middle;height: 90%">
        <div class="header_left">
        </div>
        <div class="header_right">
          <span v-if="userInfo" class="header_but" @click="handleStudyCenter">欢迎您，{{ userInfo.nickname }}</span>
          <el-divider v-if="userInfo" direction="vertical" class="divider" />
          <span v-if="userInfo" class="header_but" @click="signOut">退出</span>
          <span v-else class="header_but" @click="signIn">登录</span>
        </div>
        <div v-if="!isMobile" class="search" style="position: absolute;top: 60%;right: 5%;width: 40%">
          <el-input v-model="form.title" placeholder="请输入关键字" style="background: rgba(255,255,255,0.6);width: 100%"  @keyup.enter.native="homeSearch">
            <el-button slot="append" icon="el-icon-search" style="background: #FF4E21 !important;color: #FFFFFF;border-radius: 2px" @click="homeSearch"></el-button>
          </el-input>
        </div>
        <el-menu  :default-active="defaultActiveIndex"
                  class="el-menu-demo header_nav"
                  mode="horizontal"
                  @select="handleSelect"
                  text-color="#fff"
                  active-text-color="#fff"
                  style="height: 70px"
                  :unique-opened="true"
        >
          <el-menu-item class="menu-item" index="0">首页</el-menu-item>
          <div v-for="(item,index) in columnTreeList" :key="index">
            <el-menu-item v-if="item.columnCode!='project'" class="menu-item"  :index="item.id+''">
              {{ item.columnName }}
            </el-menu-item >
            <el-submenu @click.native="handleSubmenu(item)"  popper-class="custom-submenu"  style="padding: 8px;height: 40px" v-if="item.columnCode=='project'"  :index="item.id+''">
              <template slot="title">
                <div :style="{fontWeight:defaultActiveIndex == item.id? 'bold':'400'}">
                  {{ item.columnName }}

                </div>
              </template>
              <el-menu-item  class="menu-item-group" v-for="(itemchild,index) in projectTypeList" :key="index" :index="itemchild.id+''">
                <template slot="title">{{ itemchild.name }}</template>
              </el-menu-item>
            </el-submenu>
          </div>

        </el-menu>
<!--        <ul class="header_nav" v-if="!isMobile">-->
<!--          <li  class="header_nav_item nav_opacity" :class="{-->
<!--            header_nav_item_active: activeIndex === ''-->
<!--          }" @click="toUrl()"><span>首页</span></li>-->
<!--          <li v-if="isMobile == null" class="header_nav_item nav_opacity" v-for="(item, i) in columnTreeList" :key="i"-->
<!--            :class="{-->
<!--              header_nav_item_active: activeIndex === item.id-->
<!--            }" @click="toUrl(item)">-->
<!--            <span>-->
<!--              {{ item.columnName }}-->
<!--            </span>-->
<!--          </li>-->
<!--        </ul>-->

        <div v-if="isMobile" class="menu" v-clickoutside="closeBox">
          <ul @click="getShow">
            <li :class="isShow === false ? 'el-icon-arrow-down' : 'el-icon-notebook-2'" style="margin: 10% 0"></li>
            <li :style="{ 'display': isShow ? 'none' : 'block' }" :class="{
              header_nav_item_active: activeIndex === ''
            }" @click="toUrl()"><span>首页</span></li>
            <li :style="{ 'display': isShow ? 'none' : 'block' }" v-for="(item, i) in columnTreeList" :key="i" :class="{
              header_nav_item_active: activeIndex === item.id
            }" @click="toUrl(item)">
              <span>
                {{ item.columnName }}
              </span>
            </li>
            <li :style="{ 'display': isShow ? 'none' : 'block' }" style="margin: 30% 0"></li>
          </ul>
        </div>

        <!--      <el-divider class="home-hr"/>-->
      </div>
      <div class="main-core-content">
        <slot></slot>
      </div>
      <div>
        <Footer :top-height="20"></Footer>
      </div>
    </el-header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apis from '@/apis/student/home'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import getLocal from '@/common/cookie'
import { JSEncrypt } from 'jsencrypt'
import constant from '@/constant'
import columnApis from '@/apis/column'
// 监听点击事件

export default {
  directives: { Clickoutside },
  data () {
    return {
      form: {
        title: ''
      },
      title: '',
      columnTree: [],
      dictList: [],
      isShow: true,
      innerHeight: 0,
      isMobile: null,
      userInfo: null,
      activeIndex: '',
      defaultActiveIndex: '0',
      projectTypeList: [
        {
          id: 1,
          name: '人才需求'
        },
        {
          id: 2,
          name: '技术需求'
        },
        {
          id: 3,
          name: '出海需求'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['columnTreeList', 'activeIndex', 'user', 'websitBanner', 'isMemberUnit', 'memberUnitId'])
  },
  mounted () {
    // this.websitBanner = getWebsitBanner()
    this.innerHeight = parseInt(window.innerHeight) * 0.32
    this.ismobile()
    window.addEventListener('scroll', this.showHeader)
  },
  created () {
    if (this.user) {
      this.userInfo = this.user
    } else {
      let keyValue = localStorage.getItem('user')
      if (keyValue !== null && keyValue !== undefined && keyValue.indexOf('[object Object]') <= -1) {
        this.userInfo = JSON.parse(keyValue)
      } else {
        this.userInfo = null
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.showHeader)
  },
  methods: {
    handleSubmenu (item) {
      this.defaultActiveIndex = item.id
      this.toUrl(item, null)
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      var col = this.columnTreeList.find(e => parseInt(e.id) === parseInt(keyPath[0]))
      if(col){
        this.defaultActiveIndex = col.id
      }else{
        this.defaultActiveIndex ='0'

      }
      this.toUrl(col, keyPath)
    },
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    closeBox () {
      if (!this.isShow) {
        this.getShow()
      }
    },
    getShow () {
      this.isShow = !this.isShow
    },
    showHeader () {
      // 获取当前滚动条向下滚动的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let nav = document.querySelector('.header_nav')
      // 当页面滚动到高度300px处时，导航浮动
      if (scrollTop > 380) {
        nav.classList.add('fixedNav')
      } else {
        nav.classList.remove('fixedNav')
      }
    },
    registerMessage () {
      this.$router.push({
        path: '/generalregister'
      })
    },
    signIn () {
      this.$router.push({
        path: '/login'
      })
    },
    handleStudyCenter () {
      this.$router.push({
        path: '/newstudycenter'
      })
    },
    signOut () {
      apis.logout().then(res => {
        if (res) {
          this.$store.dispatch('logout')
          this.$store.dispatch('removeRedirect')
          this.$store.commit('SET_USER')
          this.$cookie.delete('token')
          this.$store.commit('SET_ACTIVEINDEX', '')
          localStorage.removeItem('user')
          localStorage.removeItem('accessToken')
          this.$store.commit('SET_MEMBER_UNIT_ID', null)
          this.$store.commit('SET_IS_MEMBER_UNIT', false)
          this.getColumnTreeList()
          this.userInfo = null
          this.$nextTick(() => {
            this.$router.push({
              path: '/home'
            })
          })
        } else {
          this.$message.warning(msg)
        }
      })
    },
    async getColumnTreeList () {
      await columnApis.listColumnTree().then(res => {
        var arry = res.filter(e => e.columnCode !== 'graph')
        console.log(arry)
        this.$store.commit('SET_COLUMNTREELIST', arry)
      })
    },
    toUrl (item, keyPath) {
      if (item) {
        if (item.isExtralinks === 1) {
          var url = item.extralinksUrl
          const token = getLocal.getCookie('token')
          const encryptor = new JSEncrypt() // 创建加密对象实例
          encryptor.setPublicKey(constant.PUBLICKEY) // 设置公钥
          if (token && url.indexOf('ndlink.cn') > 0) {
            if (this.user) {
              var data = {
                mobile: this.user.mobile,
                realName: this.user.realName,
                openid: this.user.openid,
                unionid: this.user.unionid
              }
              url = url + '?code=saas&key=' + encryptor.encrypt(JSON.stringify(data))
            }
          }
          if (token && url.indexOf('iacove.com') > 0) {
            var iacoveUrl = 'nationCode=86&mobile=' + this.user.mobile + '&redirectUrl=' + url
            console.log(iacoveUrl)
            var key = encryptor.encrypt(iacoveUrl)
            url = 'https://iacove.com/user/thirdLoginMobile?encryptCode=' + encodeURIComponent(key)
          }
          if (item.openWith === 2) {
            window.open(url)
          } else {
            window.location.href = url
          }
        } else if (item.isExtralinks === 0) {
          this.$store.commit('SET_COLUMNITEM', item)
          this.$store.commit('SET_COLUMNITEM_PARENT', item)
          this.$store.commit('SET_ACTIVEINDEX', item.id)
          var query = { columnId: item.id, activeChildrenIndex: item.id }
          console.log(query)
          console.log(keyPath)
          if (keyPath && keyPath.length >= 2) {
            query['projectType'] = keyPath[1]
          }
          this.$router.push({
            path: '/' + item.columnCode,
            query: query,
            name: item.columnCode
          })
        } else {
          this.$store.commit('SET_COLUMNITEM', item)
          this.$store.commit('SET_COLUMNITEM_PARENT', item)
          this.$store.commit('SET_ACTIVEINDEX', item.id)
          this.$router.push({ path: '/secondlist', query: { activeChildrenIndex: item.id } })
        }
      } else {
        this.$store.commit('SET_COLUMNITEM', [])
        this.$store.commit('SET_COLUMNITEM_PARENT', [])
        this.$store.commit('SET_ACTIVEINDEX', '')
        this.$router.push({
          path: '/home'
        })
      }
    },
    homeSearch () {
      localStorage.setItem('keywords', this.form.title)
      this.form.title = ''
      this.$store.commit('SET_ACTIVEINDEX')
      this.$router.push({
        path: '/sitesearch'
      })
    },
    handlePersonal () {
      this.$router.push({
        path: '/personalcenter'
      })
    },
    handleEditPass () {
      this.$router.push({
        path: '/editpass'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url('../assets/css/bass.css');

.fixedNav {
  position: fixed !important;
  top: -21px !important;
  z-index: 999;
  width: 99%;
}

@media (max-width: 950px) {
  .fixedNav {
    width: 100%;
  }
}

.header_nav {
  display: flex;
  justify-content: center;
  position: relative;
  font-size: 1.3rem;
  font-weight: normal;
  color: #ffffff;
  line-height: 22px;
  top: -43px;
  /*bottom: 113px;*/
  background: url("../assets/bgnav.jpg") no-repeat;
  background-size: 100% 100%;
  padding: 0;

  li {
    list-style: none;
    text-align: center;
    line-height: 28px;
    padding: 8px;
    height: 30px;
    width: 100px;
    margin: 0 7px;
  }
}

.header_nav_ul {
  display: flex;
  justify-content: center;
  position: relative;
  font-size: 1.3rem;
  font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;
  font-weight: normal;
  color: #ffffff;
  line-height: 22px;
  top: -43px;
  /*bottom: 113px;*/
  background: url("../assets/bgnav.jpg") no-repeat;
  background-size: 100% 100%;
  padding: 0;
  z-index: 9;

  li {
    list-style: none;
    text-align: center;
    line-height: 28px;
    padding: 10px;
    height: 30px;
    width: 100px;
    margin: 0 15px;
  }
}

@media (max-width: 950px) {
  .header_nav {
    display: block;
    min-height: 20px;
    z-index: 9;
    background: none;
    li {
      white-space: nowrap;
      overflow: hidden;
    }
  }

}
.header_nav_item {
  padding: 1rem 1.5rem;
  cursor: pointer;

  :hover {
    font-weight: bold;
  }
}

.header_nav_item_active {
  color: #ffffff;
  font-weight: bold;
  background-size: 100% 100%;
  border-radius: 5px 5px 0px 0px;
}

@media (max-width: 950px) {
  .header_nav_item_active {
    color: #D95108 !important;
    font-weight: bold;
    background-size: 100% 100%;
    border-radius: 5px 5px 0px 0px;
  }
}
.home-hr {
  margin-top: -2px;
  border: solid 2px #D95108;
  background-color: #D95108;
  opacity: 1;
  width: 99.7%;
}

.search-button {
  width: 55px;
  height: 40px;
  background: #D95108;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 0px;
}

.demo-form-inline {
  display: -webkit-box;
  display: -ms-flexbox;
  position: relative;
  width: 274px;
  height: 90px;
  left: 75rem;
}

.el-form--inline .el-form-item {
  margin-right: 0px;
}

.el-input__inner {
  order-radius: 0px;
}

.header_left {
  width: 90%;
  /*height: 70px;*/
  padding: 22px 0px 0px 40px;
}

.header_logo {
  font-size: 30px;
  color: #D95108;
  font-weight: 900;
  margin-top: 55px;
  width: 50%;
  margin-left: 19%;

  img {
    width: 100%;
  }
}

.header_logo_eg {
  font-size: 18px;
  color: #D95108;
  font-weight: 600;
}

.main-core-content {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
}

@media (max-width: 950px) {
  .main-core-content {
    width: 100%;
    margin-top: -35px;
    //margin: 0;
  }
}

.header_right {
  position: absolute;
  top: 40px;
  right: 30px;

  span {
    cursor: pointer;
  }
}

.header_but {
  font-size: 16px;
  font-weight: normal;
  color: #fff;
  border: none;
}
@media (max-width: 950px) {
  .header_right {
    top: 9px;
    font-size: 12px;
    right: 10px;
  }

  .header_but {
    font-size: 10px !important;
  }

  /deep/.el-divider--vertical {
    margin: 0 2px;
  }
}

/deep/.divider {
  background-color: #D95108 !important;
  margin-bottom: 2px;
  width: 2px;
}

.search {
  position: absolute;
  float: right;
  bottom: 0.5rem;
  right: 3rem;
  width: 50%;
  .el-input {
    width: 11rem;
  }
}

.ndata {
  width: 100%;
}

.ndata-head {
  position: relative;
  width: 100%;
  height: 250px;
}

@media (max-width: 950px) {
  .ndata-head {
    height: 80px;
    /*z-index: -1;*/
  }
}

/deep/ .el-header {
  padding: 0px;
}

@media (max-width: 950px) {

  /* 初始状态下的样式 */
  .menu ul {
    list-style-type: none;
    padding: 0;
    top: 48px;
    right: 5px;
    position: fixed;
    z-index: 999;
    text-align: center;
    /*background:#4444445e;*/
    background: #ffffffd9;
    min-width: 80px;
    min-height: 30px;
    margin-right: 5px;
    line-height: 30px;
    border-radius: 50px;
    box-shadow: 1px 1px 3px 1px rgba(51, 51, 51, 0.3);
  }

  .menu li {
    display: block;
    /*color: #ffffff;*/
    margin-bottom: 5px;
  }

  .menu span {
    display: block;
    padding: 5px 10px;
    /*color: #acadba;*/
    text-decoration: none;
    /*border-bottom: 1px solid #acadba;*/
  }

  /* 折叠状态下的样式 */
  .menu li ul {
    display: none;
  }

  /* 悬浮状态下的样式 */
  .menu li:hover ul {
    display: block;
    position: absolute;
    left: 100%;
    top: 0;
  }

  .menu li:hover ul li {
    display: block;
    margin-left: 0;
  }
}
.search {
  /deep/ .el-input__wrapper {
    background-color: rgba(255, 215, 184, 0.3) !important;
  }

  /deep/ .el-input__inner {
    background-color: rgba(255, 215, 184, 0.3) !important;
    color: #333;
  }

  /deep/ .input:-webkit-autofill {
    -webkit-text-fill-color: #333;
    transition: background-color 5000s ease-out 0.5s;
  }

  /deep/ input::-webkit-input-placeholder {
    color: #333;
  }
}
/deep/.menu-item{
  background:none!important;
  font-size: 20px;
}
/deep/ .el-menu-item.is-active{
    font-weight: bold !important;
}
/deep/ .el-submenu.is-active{
    font-weight: bold !important;
}
/deep/ .el-submenu.is-active > .el-submenu__title{
  font-weight: bold !important;
}
///deep/ .el-submenu.is-active > .el-submenu__title i{
//  font-weight: bold !important;
//}
/deep/ .header_nav li{
  width: auto !important;
  height: 70px;
  padding: 1.3rem 1.5rem;
}
/deep/ .el-menu-item:hover{
  font-weight: bold;
}
/deep/ .el-submenu:hover{
  font-weight: bold;
}
/deep/ .el-submenu:focus{
  font-weight: bold;
}
.el-menu--horizontal > .el-menu-item{
  border-bottom: none!important;
}
.el-menu--horizontal > .el-submenu{
  border-bottom: none!important;
}
/deep/ .el-submenu__title{
  font-size: 20px !important;
  .el-icon-arrow-down{
    display: none;
  }
}
/deep/ .el-submenu__title:hover{
  background: none;
}
.custom-submenu {
  .el-menu {
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.3);
  }

  .el-menu-item {
    color: #666 !important;
    font-size: 18px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255,255,255,0.1) !important;
      color: #D95108 !important;
    }
    &.is-active {
      color: #D95108 !important;
      border-left: 3px solid #D95108;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu-layout.vue